import { render, staticRenderFns } from "./BulkWorkflowModal.vue?vue&type=template&id=37ac6ab5"
import script from "./BulkWorkflowModal.vue?vue&type=script&lang=js"
export * from "./BulkWorkflowModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports